const AUTHENTICATION = 'autenticacion'
const PRIVATE = 'privado'
const LOGIN = 'login'
const RECOVER_PASSWORD = 'recuperar-contrasena'
const CREATE_PASSWORD = 'crear-contrasena'
const FORGOT_PASSWORD = 'cambiar-contrasena'
const TERMS_CONDITIONS = 'terminos-condiciones'
const CONTACTUS = 'contactanos'
const FREQUENT_QUESTIONS = 'preguntas-frecuentes'
const REPRESENTATIVES = 'representantes'
const GOAL_ASSIGNMENT = 'asignacion-meta'
const SIMULATOR = 'simulador'
const DATA_PRIVACY_POLICY = 'politica-privacidad-datos'
const ADMIN = 'administrar'
const DETAILS = 'consulta-detalles'
const DATA_VERIFICATION = 'verificacion-datos'
const AVAILABLE_DESTINATIONS = 'destinos-disponibles'
const SELECTED_DESTINATIONS = 'destinos-seleccionado'
export const PACKAGES_LIST = 'listado-paquetes'

export const urlRoutes = {
  public: {
    url: '/*',
    auth: {
      url: `/${AUTHENTICATION}/*`,
      login: {
        url: `/${LOGIN}`,
        urlTo: `/${AUTHENTICATION}/${LOGIN}`,
      },
      recoverPassword: {
        url: `/${RECOVER_PASSWORD}`,
        urlTo: `/${AUTHENTICATION}/${RECOVER_PASSWORD}`,
      },
      createPassword: {
        url: `/${CREATE_PASSWORD}`,
        urlTo: `/${AUTHENTICATION}/${CREATE_PASSWORD}`,
      },
      forgotPassword: {
        url: `/${FORGOT_PASSWORD}`,
        urlTo: `/${AUTHENTICATION}/${FORGOT_PASSWORD}`,
      },
    },
    footer: {
      url: `/*`,
      contactUs: {
        url: `/${CONTACTUS}`,
        urlTo: `/${CONTACTUS}`,
      },
      frequentQuestions: {
        url: `/${FREQUENT_QUESTIONS}`,
        urlTo: `/${FREQUENT_QUESTIONS}`,
      },
      termsAndConditions: {
        url: `/${TERMS_CONDITIONS}`,
        urlTo: `/${TERMS_CONDITIONS}`,
      },
      dataPrivacyPolicy: {
        url: `/${DATA_PRIVACY_POLICY}`,
        urlTo: `/${DATA_PRIVACY_POLICY}`,
      },
    },
    simulator: {
      url: `/${SIMULATOR}`,
      urlTo: `/${SIMULATOR}`,
    },
  },
  private: {
    url: `/${PRIVATE}/*`,
    representatives: {
      url: `/*`,
      load: {
        url: `/${REPRESENTATIVES}/${DETAILS}`,
        urlTo: `/${PRIVATE}/${REPRESENTATIVES}/${DETAILS}`,
      },
      admin: {
        url: `/${REPRESENTATIVES}/${ADMIN}/:representativeId`,
        urlTo: `/${PRIVATE}/${REPRESENTATIVES}/${ADMIN}`,
      },
      dataVerification: {
        url: `/${REPRESENTATIVES}/${ADMIN}/:representativeId/${DATA_VERIFICATION}/:studentId`,
        urlTo: `/${PRIVATE}/${REPRESENTATIVES}/${ADMIN}`,
      },
    },
    goalAssignment: {
      url: `/${GOAL_ASSIGNMENT}`,
      urlTo: `/${PRIVATE}/${GOAL_ASSIGNMENT}`,
    },
    availableDestinations: {
      url: `/${AVAILABLE_DESTINATIONS}`,
      urlTo: `/${PRIVATE}/${AVAILABLE_DESTINATIONS}`,
    },
    availablePackagesByDestinationId: {
      url: `/${AVAILABLE_DESTINATIONS}/:destinationId/${PACKAGES_LIST}`,
      urlTo: `/${PRIVATE}/${AVAILABLE_DESTINATIONS}`,
    },
    selectedDestinations: {
      url: `/${SELECTED_DESTINATIONS}`,
      urlTo: `/${PRIVATE}/${SELECTED_DESTINATIONS}`,
    },
  },
}
